module.exports = "//public.getcloudapp.com/packs/media/images/icon-muted-015c9d8bdb24f1781d8700e7122627a8.svg";